<!-- 操作日志 -->
<template>
    <div>
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入账户名称或手机号"
            ></Input>
            <DatePicker
                class="w200 mr24 mb24"
                type="daterange"
                split-panels
                placement="bottom-start"
                placeholder="选择时间段"
                @on-change="changeDate"
            ></DatePicker>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="user">
                    <div>{{ row.user.user ? row.user.user : "" }}</div>
                </template>
            </Table>
            <div class="ta-r mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { action_index } from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                keywords: "",
                start: "",
                end: "",
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "操作人员", slot: "user", align: "center" },
                { title: "终端", key: "terminal_text", align: "center" },
                { title: "IP", key: "ip", align: "center" },
                { title: "操作记录", key: "action", align: "center" },
                { title: "操作时间", key: "created_at", align: "center" },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            action_index(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        changeDate(e) {
            if (e[0]) {
                this.storePrams.start = e[0];
                this.storePrams.end = e[1];
            } else {
                this.storePrams.start = "";
                this.storePrams.end = "";
            }
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.ta-r {
    text-align: right;
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>